<div class="surface-200 text-primary py-2 px-3 border-round font-bold text-sm" *ngIf="formType === 'walk-in-trial'">
  <i class="fa fa-people-arrows mr-2"></i>
  <span>{{'Shared.CREATE-PROSPECT.HEADER_TRIAL' | translate}}</span>
</div>

<div [formGroup]="parentForm" class="md:px-3 py-3">
  <!-- <div class="col-12 mb-3">
    <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'TRIAL.TYPE' | translate}}</label>
    <ul class="m-0 p-0 list-none flex text-sm border-round" *ngIf="trialMaster">
      <li>
        <a pRipple
          class="cursor-pointer block px-3 py-2 w-8rem text-white transition-all transition-duration-150 text-center bg-primary border-round-left border-right-1 border-white">
          {{ isDaysBasedTrial() ? ('ADMIN.TRIAL.MEMBERSHIP' | translate) : ('ADMIN.TRIAL.CLASS' | translate) }}
        </a>
      </li>
      <li>
        <a pRipple
          class="cursor-pointer block px-3 py-2 w-8rem text-white transition-all transition-duration-150 text-center border-round-right"
          [ngClass]="{'bg-primary': trial1 === 1, 'bg-gray-600': trial1 !== 1}" (click)="onTrialTypeChange(1)">{{'ADMIN.TRIAL.CLASS' | translate}}</a>
      </li>
    </ul>
  </div> -->

  <div class="grid" *ngIf="trialMaster && isDaysBasedTrial()" formGroupName="trial_membership">
    <div class="col-6 md:col-4">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="trial-start-date-label">{{'ADMIN.TRIAL.START_DATE' | translate}}</label>
      <p-datepicker 
        formControlName="trial_start_date" 
        [showIcon]="true" 
        dateFormat="M dd,yy" 
        [yearNavigator]="true"
        yearRange="2023:2030" 
        placeholder="Select Date" 
        inputStyleClass="text-sm" 
        styleClass="w-full text-sm"
        aria-label="trial-start-date-input"
        data-testid="trial-start-date-input">
      </p-datepicker>
      <app-error-msg 
        *ngIf="parentForm.get('trial_membership.trial_start_date') && parentForm.get('trial_membership.trial_start_date')?.touched && parentForm.get('trial_membership.trial_start_date')?.invalid" 
        [errors]="parentForm.get('trial_membership.trial_start_date')?.errors" 
        [fieldLabel]="'ADMIN.TRIAL.START_DATE_ERROR' | translate"
        data-testid="trial-start-date-error">
      </app-error-msg>
    </div>

    <div class="col-6 md:col-4">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="trial-preferred-time-label">{{'ADMIN.TRIAL.PREFERRED_TIME' | translate}}</label>
      <p-datepicker 
        formControlName="trial_preferred_time" 
        [showIcon]="true" 
        [timeOnly]="true" 
        hourFormat="12"
        placeholder="Select Time" 
        inputStyleClass="text-sm" 
        styleClass="w-full text-sm"
        aria-label="trial-preferred-time-input"
        data-testid="trial-preferred-time-input">
      </p-datepicker>
      <app-error-msg 
        *ngIf="parentForm.get('trial_membership.trial_preferred_time') && parentForm.get('trial_membership.trial_preferred_time')?.touched && parentForm.get('trial_membership.trial_preferred_time')?.invalid" 
        [errors]="parentForm.get('trial_membership.trial_preferred_time')?.errors" 
        [fieldLabel]="'ADMIN.TRIAL.PREFERRED_TIME_ERROR' | translate"
        data-testid="trial-preferred-time-error">
      </app-error-msg>
    </div>

    <div class="col-12 md:col-4">
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="trial-owner-label">{{'ADMIN.TRIAL.OWNER' | translate}}</label>
      <staff-selector 
        [formGroup]="parentForm" 
        [controlName]="trialOwnerFormControl"
        [styleClass]="'w-full text-sm'"
        [placeHolder]="'SCHEDULE.CREATEAPPOINTMENT.SELECT' | translate" 
        (selectedStaff)="onTrainerChange($event)"
        aria-label="trial-owner-selector"
        data-testid="trial-owner-selector">
      </staff-selector>
      <app-error-msg 
        *ngIf="parentForm.get('trial_membership.trial_owner') && parentForm.get('trial_membership.trial_owner')?.touched && parentForm.get('trial_membership.trial_owner')?.invalid" 
        [errors]="parentForm.get('trial_membership.trial_owner')?.errors" 
        [fieldLabel]="'TRIAL.OWNER_ERROR' | translate"
        data-testid="trial-owner-error">
      </app-error-msg>
    </div>

    <div class="col-12">  
      <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="trial-notes-label">{{'Shared.CREATE-PROSPECT.NOTES' | translate | translate}}</label>
      <textarea 
        pInputTextarea 
        formControlName="notes" 
        class="w-full h-3rem"
        aria-label="trial-notes-input"
        data-testid="trial-notes-input">
      </textarea>
      <app-error-msg 
        *ngIf="parentForm.get('trial_membership.notes') && parentForm.get('trial_membership.notes')?.touched && parentForm.get('trial_membership.notes')?.invalid" 
        [errors]="parentForm.get('trial_membership.notes')?.errors" 
        [fieldLabel]="'TRIAL.NOTES_ERROR' | translate"
        data-testid="trial-notes-error">
      </app-error-msg>
    </div>
  </div>

  <div class="grid" *ngIf="trialMaster && !isDaysBasedTrial()">
    <!-- Trial Selection Dropdowns -->
    <div class="col-12" formGroupName="trial_selections">
      <div class="col-12 md:col-8" *ngFor="let index of getTrialSelections().slice(0, trialCount); let i = index">
        <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="trial-selection-{{i+1}}-label">
          {{'ADMIN.TRIAL.SELCT_TRIAL_N_OF' | translate: {n: i + 1, maxTrialAllowed: maxTrialAllowed} }}
        </label>
        <p-select 
          [options]="classList" 
          [formControlName]="'trial_' + i"
          optionLabel="name"
          styleClass="w-full text-sm text-900" 
          [placeholder]="'ADMIN.TRIAL.SELECT_TRIAL_PLACEHOLDER' | translate"
          (onChange)="onTrialSelect($event, i)"
          aria-label="trial-selection-{{i+1}}-dropdown"
          data-testid="trial-selection-{{i+1}}-dropdown">
          <ng-template pTemplate="selectedItem">
            <div *ngIf="parentForm.get('trial_selections')?.get('trial_' + i)?.value" class="text-sm flex align-items-center text-900">
              <strong class="font-bold">{{parentForm.get('trial_selections')?.get('trial_' + i)?.value?.name}}</strong>
              <span class="ml-2">{{parentForm.get('trial_selections')?.get('trial_' + i)?.value?.desc}}</span>
            </div>
          </ng-template>
          <ng-template let-trial pTemplate="item">
            <div class="text-sm flex align-items-center text-900">
              <strong class="font-bold">{{trial.name}}</strong>
              <span class="ml-2">{{trial.desc}}</span>
            </div>
          </ng-template>
        </p-select>
        <app-error-msg 
          *ngIf="parentForm.get('trial_selections')?.get('trial_' + i) && parentForm.get('trial_selections')?.get('trial_' + i)?.touched && parentForm.get('trial_selections')?.get('trial_' + i)?.invalid" 
          [errors]="parentForm.get('trial_selections')?.get('trial_' + i)?.errors" 
          [fieldLabel]="'TRIAL.SELECT_TRIAL_ERROR' | translate"
          data-testid="trial-selection-{{i+1}}-error">
        </app-error-msg>
      </div>
      <div class="col-12 md:col-4" *ngIf="trialCount < maxTrialAllowed">
        <p-button 
          label="{{'ADMIN.TRIAL.ADD_ANOTHER_TRIAL_CLASS' | translate}}" 
          icon="fa fa-plus-circle" 
          styleClass="text-sm" 
          (click)="onAddTrial()"
          aria-label="add-trial-button"
          data-testid="add-trial-button">
        </p-button>
      </div>
    </div>
  </div>
</div>